import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import SelectWrapper from '@/components/Base/Select/SelectWrapper';

import CheckboxSelect from '../CheckboxSelect';

import { Option } from './SelectMultiple.styles';

function SelectMultiple({
  options = [],
  defaultValues = [],
  name = '',
  placeholder = '',
  onChange = () => {},
}) {
  const [values, setValues] = useState(defaultValues);
  const didMountCurrent = useRef(false);

  const handleChange = ({ value, checked }) => {
    if (checked) {
      onChange({ key: name, values: values?.filter((item) => item !== value) });
      setValues((prevState) => prevState.filter((item) => item !== value));
    } else {
      onChange({ key: name, values: [...values, value] });
      setValues((prevState) => [...prevState, value]);
    }
  };

  const renderValue = useMemo(() => {
    const firstValue = options.find((option) => option?.value === values?.[0]);

    return firstValue?.label || null;
  }, [values, options, placeholder]);

  const clearSelectedValues = () => {
    setValues([]);
    onChange({ key: name, values: null });
  };

  useEffect(() => {
    if (didMountCurrent.current && !defaultValues?.length && values?.length) {
      setValues(defaultValues);
    } else {
      didMountCurrent.current = true;
    }
  }, [defaultValues]);

  return (
    <SelectWrapper
      renderValue={renderValue}
      name={name}
      clearSelectedValues={clearSelectedValues}
      placeholder={placeholder}
      valuesLength={values?.length}
      optionsLength={options?.length}
    >
      {({ search }) =>
        options.map((option, index) => {
          const isSelected = !!(
            Array.isArray(values) &&
            values.find((item) => item === option.value)
          );

          let isMatch = search;

          if (isMatch) {
            isMatch = option?.label
              .toLowerCase()
              .includes(search.toLowerCase().trim());
            if (!isMatch) {
              return null;
            }
          }

          return (
            <Option htmlFor={`${name}-option-${index}`} key={option.value}>
              <CheckboxSelect
                name={name}
                label={option?.label || null}
                value={option.value}
                isSelected={isSelected}
                onChange={handleChange}
              />
            </Option>
          );
        })
      }
    </SelectWrapper>
  );
}

SelectMultiple.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  ),
  defaultValues: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number])
  ),
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default memo(SelectMultiple);
